import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { HashRouter } from "react-router-dom";
import App from "./components/App";

createRoot(document.getElementById("root")).render(
  <HashRouter>
    <App />
  </HashRouter>
);
